// Sidebar entries pinned to the bottom of the menu, in render order.
export const PINNED_BOTTOM_MENU_ITEMS = ['onlineHelp', 'releaseNotes'];

// Splits the sidebar payload into the regular menu and the pinned entries, matching by
// menuItemName so a new root entry in SidebarItemData.json cannot break the order.
export const splitPinnedMenuItems = (sidebarItems) => {
    const source = Array.isArray(sidebarItems) ? sidebarItems : [];
    const isPinned = (item) => PINNED_BOTTOM_MENU_ITEMS.includes(item && item.menuItemName);

    return {
        items: source.filter((item) => !isPinned(item)),
        pinned: PINNED_BOTTOM_MENU_ITEMS
            .map((menuItemName) => source.find((item) => item && item.menuItemName === menuItemName))
            .filter(Boolean),
    };
};
